import CONFIG from './config.js';

const LOCK_ACCCESS_END_POINT = {
	LOCK_PD:`${CONFIG.BASE_URL}setting/daerah/lock`,
	LOCK_PC: `${CONFIG.BASE_URL}setting/cabang/lock`,
};

export default LOCK_ACCCESS_END_POINT;
